'use client';

export const classes = {
  app: 'h-dvh w-screen absolute top-0 left-0 overflow-hidden bg-no-repeat bg-cover bg-site-background',
  notFound:
    'size-full text-2xl text-grey-7 place-center bg-site-background dark:text-mauve-2 dark:bg-[#1a1620]',
};
